/* eslint-disable */
import { FILTER_STATUS_SELECTED } from '../Filters.types';

/**
 * Action to update the selected order statuses
 * @param {Array<OrderEntityStatus>} statuses The order statuses
 * @returns {ActionCreator<FromPayload<Array<OrderEntityStatus>, ActionMeta, FILTER_STATUS_SELECTED>>} The created `Action`
 */
const filtersStatusSelected = (statuses) => ({ fromPayload }) => {
  return fromPayload(statuses, { debounce: true }, FILTER_STATUS_SELECTED);
};

export default filtersStatusSelected;
